import { default as ImageCarousel } from './image-carousel'
export { default as Slide } from './slide'
export { default as SliderButton } from './slider-button'

export default ImageCarousel
